module.exports = __webpack_public_path__ + "static/media/1 0 Orddiktat Intro.e0728e43.mp3";